var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("v-select", {
        attrs: {
          label: "Select services",
          items: _vm.availableServices,
          dense: "",
          multiple: "",
        },
        model: {
          value: _vm.selectedServices,
          callback: function ($$v) {
            _vm.selectedServices = $$v
          },
          expression: "selectedServices",
        },
      }),
      _c(
        "v-expansion-panels",
        { attrs: { tile: "", flat: "", multiple: "" } },
        _vm._l(_vm.value, function (service, serviceName) {
          return _c(
            "v-expansion-panel",
            { key: serviceName },
            [
              serviceName === "reserves"
                ? [
                    _c("v-expansion-panel-header", [_vm._v("Reserves")]),
                    _c(
                      "v-expansion-panel-content",
                      { staticClass: "px-0" },
                      [
                        _c("Aggregate", {
                          attrs: {
                            title: "Reserve Services",
                            ItemConstructor: _vm.Services.Service.Reserve,
                            headers: [
                              {
                                text: "Reserve linked",
                                value: "projectReserveId",
                              },
                              { text: "Active", value: "active" },
                            ],
                            disabled: _vm.addReservesDisabled,
                          },
                          on: { change: _vm.change },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "item.active",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c("v-switch", {
                                      attrs: { dense: "" },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.active,
                                        callback: function ($$v) {
                                          _vm.$set(item, "active", $$v)
                                        },
                                        expression: "item.active",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.projectReserveId",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c("v-select", {
                                      attrs: {
                                        "item-text": "name",
                                        "item-value": "id",
                                        items:
                                          _vm.availableProjectReserves(item),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.reserveAssign($event, item)
                                        },
                                      },
                                      model: {
                                        value: item.projectReserveId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "projectReserveId",
                                            $$v
                                          )
                                        },
                                        expression: "item.projectReserveId",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "default",
                                fn: function (ref) {
                                  var item = ref.item
                                  return _vm._l(
                                    _vm.serviceParams("reserves"),
                                    function (param, paramName) {
                                      return _c(
                                        "v-row",
                                        {
                                          key: paramName,
                                          staticClass: "px-8",
                                          attrs: { dense: "" },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              !(
                                                paramName.includes(
                                                  "constant"
                                                ) ||
                                                paramName.includes("profile")
                                              )
                                                ? _c("InputServiceParam", {
                                                    attrs: {
                                                      label: param.title,
                                                      num_years: _vm.num_years,
                                                      year_start:
                                                        _vm.year_start,
                                                      suffix:
                                                        _vm.getSchemaProperty(
                                                          "reserves",
                                                          paramName,
                                                          "unit"
                                                        ) || "",
                                                      "input-type":
                                                        _vm.getInputComponent(
                                                          "reserves",
                                                          paramName
                                                        ),
                                                      items: param.enum || [],
                                                      "profile-type":
                                                        _vm.getSchemaProperty(
                                                          "reserves",
                                                          paramName,
                                                          "profileType"
                                                        ) || "",
                                                      "auto-allocation":
                                                        param.autoAllocation,
                                                      nullable:
                                                        param.nullable || false,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$emit(
                                                          "change"
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: item[paramName],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          paramName,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item[paramName]",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  )
                                },
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.computedValue.reserves,
                            callback: function ($$v) {
                              _vm.$set(_vm.computedValue, "reserves", $$v)
                            },
                            expression: "computedValue.reserves",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : serviceName !== "reserves"
                ? _c(
                    "span",
                    [
                      _c(
                        "v-expansion-panel-header",
                        {
                          class:
                            (service.active ? "" : "text--disabled") +
                            " text-subtitle-1 font-weight-medium",
                        },
                        [
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              Object.keys(service).includes("active")
                                ? _c(
                                    "v-col",
                                    { staticClass: "shrink mr-4" },
                                    [
                                      _c("v-switch", {
                                        staticClass: "my-0 pt-0",
                                        attrs: {
                                          dense: "",
                                          height: 25,
                                          "hide-details": "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                        model: {
                                          value: service.active,
                                          callback: function ($$v) {
                                            _vm.$set(service, "active", $$v)
                                          },
                                          expression: "service.active",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("v-col", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      service.name +
                                        " " +
                                        (service.active ? "(active)" : "")
                                    ) +
                                    " "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panel-content",
                        _vm._l(
                          _vm.serviceParams(serviceName),
                          function (param, paramName) {
                            return _c(
                              "v-card",
                              {
                                key: paramName,
                                staticClass: "grow",
                                attrs: { dense: "", flat: "" },
                              },
                              [
                                paramName === "renewables"
                                  ? [
                                      _c("Aggregate", {
                                        attrs: {
                                          title: param.title,
                                          ItemConstructor:
                                            _vm.Services[
                                              _vm.camelToPascal(serviceName)
                                            ][
                                              _vm.getSchemaProperty(
                                                serviceName,
                                                paramName,
                                                "constructor"
                                              )
                                            ],
                                          headers: [
                                            {
                                              text: "Generator linked",
                                              value: "generatorId",
                                            },
                                          ],
                                          "no-expand": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "item.generatorId",
                                              fn: function (ref) {
                                                var item = ref.item
                                                return [
                                                  _c("v-select", {
                                                    attrs: {
                                                      label: "Generator",
                                                      items:
                                                        _vm.projectGenerators,
                                                      "item-value": "id",
                                                      "item-text": "name",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$emit(
                                                          "change"
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: item.generatorID,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "generatorID",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.generatorID",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var item = ref.item
                                                return _vm._l(
                                                  _vm.serviceParams(
                                                    "renewableItem"
                                                  ),
                                                  function (param, paramName) {
                                                    return _c(
                                                      "v-row",
                                                      {
                                                        key: paramName,
                                                        attrs: { dense: "" },
                                                      },
                                                      [
                                                        !(
                                                          paramName.includes(
                                                            "constant"
                                                          ) ||
                                                          paramName.includes(
                                                            "profile"
                                                          )
                                                        )
                                                          ? _c(
                                                              "InputServiceParam",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    param.title,
                                                                  suffix:
                                                                    _vm.getSchemaProperty(
                                                                      "renewableItem",
                                                                      paramName,
                                                                      "unit"
                                                                    ) || "",
                                                                  num_years:
                                                                    _vm.num_years,
                                                                  year_start:
                                                                    _vm.year_start,
                                                                  "input-type":
                                                                    _vm.getInputComponent(
                                                                      "renewableItem",
                                                                      paramName
                                                                    ),
                                                                  "auto-allocation":
                                                                    param.autoAllocation,
                                                                  "profile-type":
                                                                    _vm.getSchemaProperty(
                                                                      "renewableItem",
                                                                      paramName,
                                                                      "profileType"
                                                                    ) || "",
                                                                  nullable:
                                                                    _vm.getSchemaProperty(
                                                                      "renewableItem",
                                                                      paramName,
                                                                      "nullable"
                                                                    ) || false,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$emit(
                                                                        "change"
                                                                      )
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    item[
                                                                      paramName
                                                                    ],
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        item,
                                                                        paramName,
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "item[paramName]",
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                )
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: service[paramName],
                                          callback: function ($$v) {
                                            _vm.$set(service, paramName, $$v)
                                          },
                                          expression: "service[paramName]",
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                                paramName === "demandID"
                                  ? [
                                      _c("v-select", {
                                        attrs: {
                                          label: "Demand",
                                          items: _vm.projectDemands,
                                          "item-value": "id",
                                          "item-text": "name",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: service[paramName],
                                          callback: function ($$v) {
                                            _vm.$set(service, paramName, $$v)
                                          },
                                          expression: "service[paramName]",
                                        },
                                      }),
                                    ]
                                  : _c("InputServiceParam", {
                                      attrs: {
                                        label: param.title,
                                        suffix:
                                          _vm.getSchemaProperty(
                                            serviceName,
                                            paramName,
                                            "unit"
                                          ) || "",
                                        num_years: _vm.num_years,
                                        year_start: _vm.year_start,
                                        "input-type": _vm.getInputComponent(
                                          serviceName,
                                          paramName
                                        ),
                                        tooltip:
                                          _vm.getSchemaProperty(
                                            serviceName,
                                            paramName,
                                            "tooltip"
                                          ) || "",
                                        items: param.enum || [],
                                        "auto-allocation": param.autoAllocation,
                                        "profile-type":
                                          _vm.getSchemaProperty(
                                            serviceName,
                                            paramName,
                                            "profileType"
                                          ) || "",
                                        nullable:
                                          _vm.getSchemaProperty(
                                            serviceName,
                                            paramName,
                                            "nullable"
                                          ) || false,
                                        max:
                                          _vm.getSchemaProperty(
                                            serviceName,
                                            paramName,
                                            "maximum"
                                          ) || "",
                                        min:
                                          _vm.getSchemaProperty(
                                            serviceName,
                                            paramName,
                                            "minimum"
                                          ) || "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: service[paramName],
                                        callback: function ($$v) {
                                          _vm.$set(service, paramName, $$v)
                                        },
                                        expression: "service[paramName]",
                                      },
                                    }),
                              ],
                              2
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-divider"),
            ],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }